import { render, staticRenderFns } from "./notActivityPirce.vue?vue&type=template&id=d1f8428a&scoped=true"
import script from "./notActivityPirce.vue?vue&type=script&lang=js"
export * from "./notActivityPirce.vue?vue&type=script&lang=js"
import style0 from "./notActivityPirce.vue?vue&type=style&index=0&id=d1f8428a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f8428a",
  null
  
)

export default component.exports